const acceptTypesFile = {
  text:'text',
  image: '.jpeg, .jpg, .png',
  video: '.mp4, .3gp',
  document:'.txt, .pdf, .ppt, .doc, .xls, .docx, .pptx, .xlsx'
}

const languageTemplates = [
  { label: 'dashboard_language_spanish', value: 'es' },
  { label: 'dashboard_language_english', value: 'en_US' },
  { label: 'dashboard_language_catalan', value: 'ca' },
  { label: 'dashboard_language_french', value: 'fr' },
  { label: 'dashboard_language_german', value: 'de' }
]

const headerTemplates = [
  { label: 'dashboard_none-female', value: 'none' },
  { label: 'dashboard_text', value: 'text' },
  { label: 'dashboard_image', value: 'image' },
  { label: 'dashboard_video', value: 'video' },
  { label: 'dashboard_document', value: 'document' },
]

const buttonsTemplates = [
  { label: 'dashboard_none', value: 'none' },
  { label: 'dashboard_quick-reply', value: 'quick_reply' },
  { label: 'dashboard_call-to-action', value: 'call_to_action' },
]

const buttonsCallToActionTemplates = [
  { label: 'dashboard_go-to-website', value: 'url' },
  { label: 'dashboard_call-phone', value: 'phone' },
]

export default {
  acceptTypesFile,
  languageTemplates,
  headerTemplates,
  buttonsTemplates,
  buttonsCallToActionTemplates
}
